/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 17:08:59
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:12:04
 * @name: 登录对象
 * @Description: 登录对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\login\login.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { login } from '@/api/user/user.api.js';
import cookie from '@/storage/cookie.js';
import localstorage from '@/storage/localstorage';
import { apiMethod } from '@/utils/decorator.js';
const loginClass = class loginClass {
    constructor() {
        this.username = new localstorage().getLoginTelephone() ?? ''; //手机号
        this.password = ''; //密码
        this.verificationCode = ''; //验证码
        this.verify = ''; //验证码图片路径
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取验证码图片
     */
    getVerify() {
        this.verify = process.env.VUE_APP_BASE_API + '/admin/user/verify.html';
        this.verify += '?d=' + new Date().getTime();
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 登录
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    submit() {
        let params = {
            username: this.username,
            password: this.password,
            verify: this.verificationCode,
        }
        return this.login(params);
    }
    @apiMethod(login)
    login(res) {
        if (res.code === 200) {
            new cookie().setRoleId(`${res.data?.user?.value ?? ''}`);
            new cookie().setAuthList(JSON.stringify(res.data?.route ?? []));
            new cookie().setToken(res.data?.token ?? '');
            new localstorage().setLoginTelephone(this.username);
        }
    }
}

export default loginClass;
